var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"trigger":"click","height":"500px"}},_vm._l((_vm.sliderData),function(item,index){return _c('el-carousel-item',{key:index},[(item.Url)?_c('a',{attrs:{"href":item.Url}},[_c('img',{attrs:{"src":item.FileUrl}})]):_c('a',[_c('img',{attrs:{"src":item.FileUrl}})])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7740bbee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = null
// module chunks = 